import styled from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const FormSection = styled.div`
  width: 100%;
  max-width: 700px;

  form {
    .row {
      margin-bottom: 24px;
    }
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
  width: 100%;
`;
